import React from "react";
import PropTypes from "prop-types";
import dynamic from "next/dynamic";
import { getColor } from "@gc-npm/utils.enums.colors";
import CustomLink from "@gc-npm/components.custom-link";

const Image = dynamic(() => import("@/component/c-image"));

const Card = ({
  hash = "",
  children,
  cardPropLayout = "capta",
  cardPropBgColor = "transparent",
  backgroundImg = "",
  className = "",
  title = "",
  href = "",
  onClick,
  taggingInfo,
  isDeviceCard = false,
  accessibleRole,
  ariaChecked
}) => {
  if (!children) return null;

  const cardStyle = {
    backgroundColor: backgroundImg
      ? getColor("black")
      : getColor(cardPropBgColor),
  };

  return (
    <>
      {!href && !onClick && (
        <div
          className={`card layout-${cardPropLayout} ${className}`}
          style={cardStyle}
        >
          {backgroundImg && (
            <Image
              hash={hash}
              className="card-backgroundImg"
              src={backgroundImg}
              alt=""
              fill
            />
          )}
          <div className="card-container">{children}</div>
        </div>
      )}
      {(href || onClick) &&
        (!isDeviceCard ? (
          <CustomLink
            href={href}
            onClick={onClick}
            title={title}
            taggingInfo={taggingInfo}
            className={`card layout-${cardPropLayout} ${className}`}
            style={cardStyle}
            accessibleRole={accessibleRole}
            ariaChecked={ariaChecked}
            internal
          >
            {backgroundImg && (
              <Image
                hash={hash}
                className="card-backgroundImg"
                src={backgroundImg}
                alt=""
                fill
              />
            )}
            <div className="card-container">{children}</div>
          </CustomLink>
        ) : (
          <CustomLink
            href={href}
            onClick={onClick}
            title={title}
            style={cardStyle}
            taggingInfo={taggingInfo}
            accessibleRole={accessibleRole}
            ariaChecked={ariaChecked}
          >
            <div className={`card layout-${cardPropLayout} ${className}`}>
              {backgroundImg && (
                <Image
                  hash={hash}
                  className="card-backgroundImg"
                  src={backgroundImg}
                  alt=""
                  fill
                />
              )}
              <div className="card-container">{children}</div>
            </div>
          </CustomLink>
        ))}
    </>
  );
};

Card.propTypes = {
  cardPropLayout: PropTypes.string,
  cardPropBgColor: PropTypes.string,
  backgroundImg: PropTypes.string,
  className: PropTypes.string,
  title: PropTypes.string,
  href: PropTypes.string,
  onClick: PropTypes.func,
  taggingInfo: PropTypes.object,
};

Card.defaultProps = {
  cardPropLayout: "capta",
  cardPropBgColor: "transparent",
  backgroundImg: "",
  className: "",
  title: "",
  onClick: null,
  taggingInfo: {},
  href: "",
};

export default Card;
